module.exports = __webpack_public_path__ + "frontend/images/agents/provide-electrical-50fb556d8c32ad5c447aa8825d201557.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/agents/provide-electrical.png
// module id = 365
// module chunks = 2